import Vue from "vue";
import VueRouter from "vue-router";
import Index from '@/views/Index'

Vue.use(VueRouter);

const prefix='10663|10664|10665|prod';

const routes = [

  {
    path: '/',
    name: 'Index',
    meta:{
      index:0,
      title:'',
      needShare:false
    },
    component: Index,
  },
  {
    path: '/login.html',
    name: 'Login',
    meta:{
      index:0,
      title:'',
      needShare:false
    },
    component:() => import('@/views/Login')
  },
  {
    path: '/upload.html',
    name: 'Upload',
    meta:{
      index:0,
      title:'',
      needShare:false,
      tabbar:1
    },
    component:() => import('@/views/Upload')
  },
  {
    path: '/rule.html',
    name: 'Rule',
    meta:{
      index:0,
      title:'',
      needShare:false,
      tabbar:1
    },
    component:() => import('@/views/Rule')
  },
  {
    path: '/center.html',
    name: 'Center',
    meta:{
      index:0,
      title:'',
      needShare:false,
      tabbar:1
    },
    component:() => import('@/views/Center')
  },

  {
    path: `/:prefix(${prefix})/index.html`,
    name: 'Index',
    meta:{
      index:0,
      title:'',
      needShare:false,
    },
    component:() => import('@/views/Index')
  },
  {
    path: `/:prefix(${prefix})/login.html`,
    name: 'Login',
    meta:{
      index:0,
      title:'',
      needShare:false,
    },
    component:() => import('@/views/Login')
  },
  {
    path: `/:prefix(${prefix})/upload.html`,
    name: 'Upload',
    meta:{
      index:0,
      title:'',
      needShare:false,
      tabbar:1,
    },
    component:() => import('@/views/Upload')
  },
  {
    path: `/:prefix(${prefix})/rule.html`,
    name: 'Rule',
    meta:{
      index:0,
      title:'',
      needShare:false,
      tabbar:1,
    },
    component:() => import('@/views/Rule')
  },
  {
    path: `/:prefix(${prefix})/center.html`,
    name: 'Center',
    meta:{
      index:0,
      title:'',
      needShare:false,
      tabbar:1,
    },
    component:() => import('@/views/Center')
  },

  {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  //用你的方式获取登录的用户信息
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
router.afterEach((to,form)=>{
  setTimeout(function (){
    /*document.querySelector('#app').scrollTo(0, 0);*/
    window.scrollTo(0, 0);
  },200);
  /*
  * wechat.setShare(
        '欢迎参加赛事报名',
        '点击查看最新比赛详情',
        window.location.href,
        'https://xxx.com/icon.jpg'
      );*/
});

export default router;
